import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {ScrollingModule} from "@angular/cdk/scrolling";


@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    CommonsModule,
    ScrollingModule,
  ],
  providers: [],
  exports: []
})

export class CustomersModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(CustomersModule);
};

export const downgradedCustomersModule = downgradeModule(bootstrapModule);
